var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-verify",attrs:{"data-automation":"imgVerify"}},[_c('img',{staticClass:"img-verify-src",attrs:{"src":_vm.imgSrc},on:{"click":_vm.getKaptcha}})])}
var staticRenderFns = []

export { render, staticRenderFns }